// extracted by mini-css-extract-plugin
module.exports = {"marquee-container":"MarqueStripe_marquee-container__TebUS","marquee":"MarqueStripe_marquee__0y6DJ","dot":"MarqueStripe_dot__sEOF9","text":"MarqueStripe_text__riWqW"};